module.exports.main = `
  INSERT INTO fin.creditmemo (
      origin, company, txn_id, txn_date,
      doc_no, customer_id, amount, unapplied_amount, currency, private_note
  )
  SELECT origin
       , company
       , txn_id
       , txn_date
       , data->>'DocNumber' as doc_no
       , (data->'CustomerRef'->>'value')::INTEGER as customer_id
       , (data->>'TotalAmt')::NUMERIC as amount
       , (data->>'RemainingCredit')::NUMERIC as unapplied_amount
       , (data->'CurrencyRef'->>'value')::fin.currency_type as currency
       , (data->>'PrivateNote') as private_note
  FROM raw
`
module.exports.line = `
  INSERT INTO fin.creditmemo_line (
      origin, company, txn_id, line_num,
      account_id, amount, item_id, quantity, unit_price, tax_code, description
  )
  SELECT origin
       , company
       , txn_id
       , line_num
       , (line->'SalesItemLineDetail'->'ItemAccountRef'->>'value')::INTEGER as account_id
       , (line->'Amount')::NUMERIC as amount
       , (line->'SalesItemLineDetail'->'ItemRef'->>'value')::INTEGER as item_id
       , (line->'SalesItemLineDetail'->>'Qty')::NUMERIC as quantity
       , (line->'SalesItemLineDetail'->>'UnitPrice')::NUMERIC as unit_price
       , (line->'SalesItemLineDetail'->'TaxCodeRef'->>'value') as tax_code
       , line->>'Description' as description
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line')
             WITH ORDINALITY AS l(line, line_num) ON TRUE
  WHERE line->>'DetailType' = 'SalesItemLineDetail'
`

module.exports.rawCustomerIds = `
  SELECT origin
       , company
       , (data->'CustomerRef'->>'value')::INTEGER as customer_id
  FROM raw
`

module.exports.rawAccountIds = `
  SELECT origin
         , company
         , (line->'SalesItemLineDetail' -> 'ItemAccountRef' ->> 'value')::integer AS account_id 
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line') AS line on true
  WHERE line -> 'Id' IS NOT NULL
`
